export default __webpack_public_path__ + "static/media/Karima-profile.d66b088b.jpg";